console.log('js');

$( document ).ready(function() {
  //console.log( "ready!" );
  
  //remove quantity and add to cart from free gift card product page
  removeElement(".product.yopandtom-gdpr .product-8059483652350 .product-quantity-box");
  removeElement(".product.yopandtom-gdpr .product-8059483652350 .purchase-details__buttons");

  //remove plus/minus buttons from free gift card in cart
  removeElement(".item-id-44040971485438 .product-minus");
  removeElement(".item-id-44040971485438 .product-plus");

  //set max from free gift card in cart
  setMax(".item-id-44040971485438 .product-quantity-box .quantity", 1);
  
  //remove links from free gift card in cart
  removeLink(".item-id-44040971485438 .cart_page_image");
  removeLink(".item-id-44040971485438 .cart__item--title a");
});

function disableField(val) {
    $(val).prop('disabled', true);
}
function removeElement(val) {
    $(val).detach();
}
function removeLink(val) {
    $(val).removeAttr("href");
}
function setMax(field,val) {
    $(field).attr('max', val);
}

//Only run on cart page
if( window.location.pathname == '/cart') {
  
  //Catch all the AJAX Request to Cart.JS and Cart/Change.JS
  $( document ).ajaxComplete(function( event, xhr, settings ) {
    if ( settings.url === "/cart.js" ) {
      //console.log( "Cart.JS = Triggered ajaxComplete handler. The result is " + xhr.responseText + ' TOTAL PRICE = ' + parseFloat( xhr.responseText.split(",")[4].split(":")[1] )/100 );
      total_price = parseFloat( xhr.responseText.split(",")[4].split(":")[1] )/100;
  
      //console.log(total_price);

      
      if(total_price < 50) {
        //console.log("Remove freebie");
        if( $('.item-id-44040971485438').length ) {
          //console.log('freebie exists');
          //$(".item-id-44040971485438 .product-quantity-box .quantity").val(0).trigger("change");
          window.location.replace('/cart/change?line=1&quantity=0');
        }
      }
    }
  
  });

}

//Redirect from free giftcard
if( window.location.pathname == '/products/giftcard-5') {
   window.location.replace('/products/giftcards');
}